<template>
  <div class="m-foot">
    <div class="m-foot-line"></div>
    <div class="tabbar" style="padding:30px 0;background-color: #f2f2f2;">
      <div style="display: flex;justify-content: center; flex-wrap: wrap;">
        <div style="display: flex;justify-content: space-around;width: 1200px;">
          <div style="display: flex;">
            <div>
              <img src="../../assets/img/p14.png" style="width: 40px; height: 40px;margin-bottom: 2px;" alt="">
            </div>
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">正品保证</div>
              <div>100%原产地</div>
            </div>
          </div>
          <div style="display: flex;">
            <div>
              <img src="../../assets/img/p13.png" style="width: 40px; height: 40px;margin-bottom: 2px;" alt="">
            </div>
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">退货无忧</div>
              <div>七天退货保障</div>
            </div>
          </div>
          <div style="display: flex;">
            <div>
              <img src="../../assets/img/p12.png" style="width: 40px; height: 40px;margin-bottom: 2px;" alt="">
            </div>
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">极速配送</div>
              <div>满98元包邮</div>
            </div>
          </div>
          <div style="display: flex;">
            <div>
              <img src="../../assets/img/p11.png" style="width: 40px; height: 40px;margin-bottom: 2px;" alt="">
            </div>
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">送货上门</div>
              <div>400城市送货上门</div>
            </div>
          </div>
        </div>
        <div style="border-top: 1px solid #dcdcdc; margin: 30px 0;width: 1200px;"></div>
        <div style="display: flex;justify-content: space-around;width: 1200px;">
          <div style="display: flex;">
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">帮助中心</div>
              <div>忘记密码</div>
              <div>积分细则</div>
              <div>查看已购买商品</div>
              <div>如何搜索</div>
              <div>我要买</div>
            </div>
          </div>
          <div style="display: flex;">
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">店主之家</div>
              <div>如何管理店铺</div>
              <div>如何发货</div>
              <div>如何申请开店</div>
              <div>查看售出商品</div>
              <div>商城商品推荐</div>
            </div>
          </div>
          <div style="display: flex;">
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">支付方式</div>
              <div>分期付款</div>
              <div>如何注册支付宝</div>
              <div>公司转账</div>
              <div>邮局汇款</div>
              <div>在线支付</div>
            </div>
          </div>
          <div style="display: flex;">
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">售后服务</div>
              <div>退换货</div>
              <div>联系卖家</div>
              <div>退换货流程</div>
              <div>退款申请</div>
              <div>退换货政策</div>
            </div>
          </div>
          <div style="display: flex;">
            <div style="margin: 0 0 0 5px;">
              <div style="font-size: 20px;">联系方式：</div>
              <div>7 x 24 小时客服在线</div>
            </div>
          </div>
        </div>
      </div>
      <div style="border-top: 1px solid #dcdcdc; margin: 40px 0;"></div>
      <p style="color: #666666;text-align: center;margin: 0 0 10px 0;">北京六十甲子系统科学研究院有限公司</p>
      <p><a style="color: #666666" href="javascript:;">出版物经营许可证：新出发京零字第顺260005号</a></p>
      <p><a style="color: #666666" target="_black" href="http://beian.miit.gov.cn/#/Integrated/index" >增值电信业务经营许可证：京B2-20250016</a></p>
      <p style="color: #666666;text-align: center;margin: 0 0 10px 0;">
        <a style="color: #666666" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="baiA">
          京ICP备2024096510号-1
        </a>
      </p>
      <p style="color: #666666; text-align: center; margin: 0 0 10px 0; height: 22px;">
        <img src="../../assets/img/gongan.png" style="width: 20px; height: 22px; vertical-align: middle;" alt="">
        <a style="color: #666666; vertical-align: middle;" href="" rel="noreferrer" target="_blank" class="baiA">
          京公网安备11011302007382
        </a>
      </p>
      <p style="color: #666666;text-align: center;margin: 0 0 10px 0;">北京市顺义区金穗路2号院9号楼8层804</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/public/Bottom.vue